import { render, staticRenderFns } from "./EhrScratchPadDialog.vue?vue&type=template&id=ab422188&scoped=true&lang=pug"
import script from "./EhrScratchPadDialog.vue?vue&type=script&lang=js"
export * from "./EhrScratchPadDialog.vue?vue&type=script&lang=js"
import style0 from "./EhrScratchPadDialog.vue?vue&type=style&index=0&id=ab422188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab422188",
  null
  
)

export default component.exports